// Acciones asincronas que pueden llamar una inforrmacion

import { LoginUser, getCarrerasService, getEstanciasService, insertarEstancias,updateEstancias } from "../helpers/services";


// Login
export const verifyUser = async ({ commit }, values) => {
  // Comportamiento dummy
  // const { username } = data
  // if (username === 'desarrollo') {
  //   const userData = {
  //     nombre: 'Administrador',
  //     correo: "desarrollo@quimica.unam.mx",
  //     rol: "A",
  //     token: "M39NomIs0v63QEf0_1G3oznCx0ZqAISohPymsayp4Bk5iFgW",
  //     logged_in: "yes"
  //   }
  //   commit('setUser', userData)
  //   let response = {
  //     status: 200,
  //     message: "Ok"
  //   }
  //   return response
  // } else {
  //   let response = {
  //     status: 404,
  //     message: "Error en usuario o contraseña"
  //   }
  //   return response
  // }
  const { tipoUsuario, username, password } = values;

  let response = {};

  if (!tipoUsuario || !username || !password) {
    response = {
      replyCode: 400,
      replyText: "Información incompleta",
    };
    commit("setUser", response);
    return;
  }

  if (Object.keys(values).length === 0) {
    response = {
      replyCode: 400,
      replyText: "Información incompleta",
    };
    commit("setUser", response);
    return;
  }

  const {data} = await LoginUser(values);
  if (Object.keys(data).length !== 0) {
    commit("setUser", data);
    return data;
  }



};
 
export const logout = ({ commit }) => {
  commit("setLogout", "");
};


// Catalogo Carreras
export const getCarreras = async ({commit}) => {
  const {data} = await getCarrerasService();
  if(Object.keys(data).length === 0) {
    // Modificar state a vacio, commit de una mutacion
    commit('setCarreras', []);
    return
  }
  const { carreras } = data;
  // Modificar el state, commit de una mutacion
  commit('setCarreras', carreras);
}

// Catalogo Estancias
export const getEstancias = async ({commit}) => {
  const {data} = await getEstanciasService();
  if(Object.keys(data).length === 0) {
    // Modificar state a vacio, commit de una mutacion
    commit('setEstancias', []);
    return
  }
  const { estancias } = data;
  // Modificar el state, commit de una mutacion
  commit('setEstancias', estancias);
}

export const insertEstancia = async(context, values) => {
  const {data} = await insertarEstancias(values);
  return data
}

export const editarEstancia = async(context, values) => {
  const {data} = await updateEstancias(values);
  return data
}